module.exports = __webpack_public_path__ + "img/img27.23282a09.svg";